import * as React from "react";
import { SVGProps } from "react";
const SvgDueDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#due-date_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1h3v1h4V1h3v1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2V1ZM2 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1H2Zm3.645 5.527H4.93v-.84h.703c.535 0 .898-.324.898-.792 0-.434-.332-.766-.882-.766-.57 0-.922.297-.961.816h-1.09c.039-1.027.84-1.726 2.11-1.726 1.25 0 1.944.691 1.94 1.515-.003.684-.433 1.13-1.039 1.282v.07c.786.117 1.262.617 1.262 1.375 0 .984-.93 1.684-2.203 1.684-1.273 0-2.14-.692-2.191-1.747h1.129c.035.489.44.797 1.046.797.598 0 1.016-.336 1.016-.832 0-.515-.39-.836-1.023-.836ZM11.915 12h-1.18V7.477h-.07l-1.383.96V7.375l1.457-1.012h1.176V12Z"
        fill="#3A86FF"
      />
    </g>
    <defs>
      <clipPath id="due-date_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDueDate;
